import { useParams } from 'react-router';
import { usePartner } from '../api/hooks/partners';
import { useMspDetailsForCustomer } from '../api/hooks/companies';

export const useCurrentMspRegion = () => {
  const { partnerId } = useParams<'partnerId'>();

  if (!partnerId) {
    throw Error('Partner ID must be provided');
  }

  const [partner] = usePartner(partnerId);
  return partner.region;
};

export const useCurrentCustomerRegion = () => {
  const { companyId } = useParams<'companyId'>();
  const { partnerId } = useParams<'partnerId'>();

  if (!companyId || !partnerId) {
    throw Error('Company ID and partner ID must be provided');
  }

  const [mspDetails] = useMspDetailsForCustomer(partnerId, companyId);
  return mspDetails.region;
};
